<div [class.example-is-mobile]="mobileQuery.matches" class="h-100">
    <mat-sidenav-container [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
        <mat-sidenav *ngIf="!IsMemberPrivilagePlan" #snav [mode]="mobileQuery.matches ? 'over' : 'side'"
            [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
            <mat-nav-list class="mb-3 mat-nav-list">
                <div class="p-1 text-center">
                    <img src="assets/images/{{logoImage}}" class="img-fluid w-50" alt="logo"
                        *ngIf="showFullMenu">
                    <img src="assets/images/{{smallLogo}}" width="50" height="50" alt="logo"
                        *ngIf="!showFullMenu">
                </div>
                <div class="px-2 py-3 text-white primaryBackgroundColor shadow w-100 row mx-0 my-1 align-items-center"
                    *ngIf="showFullMenu">
                    <div class="col-md-4 px-1">
                        <img [src]="auth.staffImage" class="img-fluid" style="border-radius: 50%;" alt="">
                    </div>
                    <div class="col-md-8 px-1">
                        <p class="mb-2">
                            {{auth.staffName}}
                        </p>
                        <p class="mb-0">
                            {{auth.roleName}}
                        </p>
                    </div>
                </div>

                <div class="py-2 text-center" *ngIf="!showFullMenu" [matTooltip]="auth.staffName"
                    matTooltipPosition="right">
                    <img [src]="auth.staffImage" width="50" height="50" style="border-radius: 50%;" alt="">
                </div>

                <a mat-list-item matTooltip="Membership Dashboard" matTooltipPosition="right"
                    routerLink="/dashboard/membership-dashboard" routerLinkActive="link-active">
                    <i class="fa fa-tachometer" aria-hidden="true"></i>
                    <span *ngIf="showFullMenu">Dashboard</span>
                </a>

                <a *ngIf="canAccessMyAppointments" mat-list-item matTooltip="My Appointments" matTooltipPosition="right"
                    routerLink="/appointments/current-appointments" routerLinkActive="link-active">
                    <i class="fa fa-user" style="margin-right: 23px;"></i>
                    <span *ngIf="showFullMenu">My Appointments</span>
                </a>
                <a *ngIf="canAccessMyTasks" mat-list-item routerLinkActive="link-active" >																											 
                    <i class="fa fa-tasks" style="margin-right: 22px;"></i>
                    <a routerLink="/my-task" [queryParams]="{tab: 'Rota'}" matTooltip=" My Tasks" matTooltipPosition="right">
                        <span> My Tasks </span>  
                    </a>
                    <a routerLink="/my-task" [queryParams]="{tab: 'Pending Appointments'}"  style="margin-left: 10px;">
                        <span *ngIf="CanAccessMyAppointments && appointmentPendingCount!==0"
                            class="badge badge-danger badge-throb mx-1 my-0"
                            matTooltip="Pending Appointments">{{appointmentPendingCount}}</span>
                    </a>                       
                 </a> 
                <a *ngIf="canAccessMemberships" mat-list-item routerLink="/membership/patient-membership"
                    routerLinkActive="link-active" matTooltip="Membership" matTooltipPosition="right">
                    <i class="fa fa-address-card"></i>
                    <span *ngIf="showFullMenu">Membership</span>
                </a>

                <mat-accordion *ngIf="showFullMenu">
                    <mat-expansion-panel *ngIf="canAccessEmails">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="fa fa-envelope"></i>
                                <span>Emails</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <a *ngIf="canAccessInbox" mat-list-item class="px-2" routerLinkActive="link-active"
                            routerLink="/email/inbox">
                            <i class="fa fa-inbox"></i>
                            <span>Inbox</span>
                        </a>
                        <a *ngIf="canComposeEmail" mat-list-item class="px-2" routerLinkActive="link-active"
                            routerLink="/email/email-compose">
                            <i class="fa fa-pencil"></i>
                            <span>Compose</span>
                        </a>
                        <a *ngIf="canViewEmailTemplate" mat-list-item class="px-2" routerLinkActive="link-active"
                            routerLink="/email/email-template-list">
                            <i class="fa fa-file-code-o"></i>
                            <span>Email Templates</span>
                        </a>
                        <a *ngIf="canViewSentEmails" mat-list-item class="px-2" routerLinkActive="link-active"
                            routerLink="/email/email-sent">
                            <i class="fa fa-paper-plane-o"></i>
                            <span>Sent Emails</span>
                        </a>
                    </mat-expansion-panel>
                    <mat-expansion-panel *ngIf="canAccessHrManagement">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="fa fa-users"></i>
                                <span *ngIf="showFullMenu">HR Management</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <a *ngIf="canAccessStaff" class="px-2" mat-list-item routerLinkActive="link-active"
                            routerLink="/hr-management/staff-list">
                            <i class="fa fa-user-md" aria-hidden="true"></i>
                            <span>Staff Management</span>
                        </a>
                        <a *ngIf="canAccessStaffSchedule" class="px-2" mat-list-item routerLinkActive="link-active"
                            routerLink="/hr-management/staff-schedule">
                            <i class="fa fa-user-md" aria-hidden="true"></i>
                            <span>Staff Schedules</span>
                        </a>
                        <a *ngIf="canAccessStaffRota" class="px-2" mat-list-item routerLinkActive="link-active"
                            routerLink="/hr-management/staff-rota">
                            <i class="fa fa-user-md" aria-hidden="true"></i>
                            <span>Staff Rota</span>
                        </a>
                    </mat-expansion-panel>
                </mat-accordion>


                <a *ngIf="canAccessInbox && !showFullMenu" mat-list-item class="px-2" routerLinkActive="link-active"
                    routerLink="/email/inbox" matTooltip="fa-inbox">
                    <i class="fa fa-inbox"></i>
                </a>
                <a *ngIf="canComposeEmail && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/email/email-compose" matTooltip="Compose Email" matTooltipPosition="right">
                    <i class="fa fa-pencil"></i>
                </a>
                <a *ngIf="canViewEmailTemplate && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/email/email-template-list" matTooltip="Email Template List" matTooltipPosition="right">
                    <i class="fa fa-file-code-o"></i>
                </a>
                <a *ngIf="canViewSentEmails && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/email/email-sent" matTooltip="Email Sent" matTooltipPosition="right">
                    <i class="fa fa-paper-plane-o"></i>
                </a>

                <a *ngIf="CanAccessCQC" mat-list-item matTooltip=" CQC Compliance" matTooltipPosition="right"
                         href="https://portal.dental-compliance.co.uk/"  target="_blank">
                          <i class="fa fa-user" style="margin-right: 23px;"></i>
                    <span *ngIf="showFullMenu">CQC Compliance</span>
                </a>
                <!-- Commented below code by Mohan for feature Development -->
                <!-- <mat-accordion *ngIf="showFullMenu">
                    <mat-expansion-panel *ngIf="CanAccessCQC">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="fa fa-book" aria-hidden="true"></i>
                                <span *ngIf="showFullMenu">CQC Compliance</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <a *ngIf="CanAccessOurPolicies" class="px-2" mat-list-item routerLinkActive="link-active"
                            routerLink="/compliance/our-polices">
                            <i class="fa fa-plus-circle" aria-hidden="true"></i>
                            <span>Our Policies</span>
                        </a>
                        <a *ngIf="CanAccessCQCUpcomingReviews" class="px-2" mat-list-item routerLinkActive="link-active"
                            routerLink="/compliance/upcoming-cqc-review">
                            <i class="fa fa-pencil-square" aria-hidden="true"></i>
                            <span>Upcoming Policy Review</span>
                        </a>
                    </mat-expansion-panel>
                </mat-accordion> -->

                <a *ngIf="CanAccessOurPolicies && !showFullMenu" class="px-2" mat-list-item
                    routerLinkActive="link-active" routerLink="/compliance/our-polices" matTooltip="Our Policies"
                    matTooltipPosition="right">
                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                </a>
                <a *ngIf="CanAccessCQCUpcomingReviews && !showFullMenu" class="px-2" mat-list-item
                    routerLinkActive="link-active" routerLink="/compliance/upcoming-cqc-review"
                    matTooltip="Upcoming Policy Review" matTooltipPosition="right">
                    <i class="fa fa-pencil-square" aria-hidden="true"></i>
                </a>

                <a *ngIf="canAccessStaff && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/hr-management/staff-list" matTooltip="Staff Management" matTooltipPosition="right">
                    <i class="fa fa-address-card-o" aria-hidden="true"></i>
                </a>
                <a *ngIf="canAccessStaffSchedule && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/hr-management/staff-schedule" matTooltip="Staff Schedules" matTooltipPosition="right">
                    <i class="fa fa-tasks" aria-hidden="true"></i>
                </a>
                <a *ngIf="canAccessStaffRota && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/hr-management/staff-rota" matTooltip="Staff Rota" matTooltipPosition="right">
                    <i class="fa fa-tasks" aria-hidden="true"></i>
                </a>
                <a *ngIf="canAccessPatients" mat-list-item routerLinkActive="link-active" >	
                        <i class="fa fa-user" style="margin-right: 22px;"></i>
                        <!-- <span> Patients </span>   -->
                        <a (click)="GetPatients()" matTooltip=" Patients" matTooltipPosition="right">                       
                            Patients
                        </a>
                        <a (click)="GetNewPatients()" matTooltip="New Patients" matTooltipPosition="right" style="margin-left: 10px;">
                            <span *ngIf="patientBadgeCount!==0" class="badge badge-danger badge-throb mx-1 my-0">{{patientBadgeCount}}</span>                                                                                                             
                        </a>                       
                    </a> 
                <mat-accordion *ngIf="showFullMenu">
                    <mat-expansion-panel *ngIf="CanAccessReferralManagement">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="fa fa-book" aria-hidden="true"></i>
                                <span *ngIf="showFullMenu">Referrals Management</span>
                                <span *ngIf="referralBadgeCount!==0" class="badge badge-danger badge-throb"
                                    matTooltip="Referrals">{{referralBadgeCount}}</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <a *ngIf="canAccessReferralsMenu" mat-list-item routerLinkActive="link-active" class="px-3"
                            routerLink="/referrals/referrals" matTooltip="Referrals" matTooltipPosition="right">
                            <i class="fa fa-handshake-o" aria-hidden="true"></i>
                            <label class="mb-0">
                                <span *ngIf="showFullMenu">Referrals</span>
                                <span *ngIf="referralBadgeCount!==0"
                                    class="badge badge-danger badge-throb mx-1 my-0">{{referralBadgeCount}}</span>
                            </label>
                        </a>
                        <a *ngIf="CanAccessPractices" mat-list-item routerLinkActive="link-active" class="px-3"
                            routerLink="/referrals/practices" matTooltip="Practices" matTooltipPosition="right">
                            <i class="fa fa-hospital-o" aria-hidden="true"></i>
                            <label class="mb-0">
                                <span *ngIf="showFullMenu">Practices</span>
                            </label>
                        </a>
                    </mat-expansion-panel>
                </mat-accordion>
                <a *ngIf="canAccessReferralsMenu && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/referrals/referrals" matTooltip="Referrals" matTooltipPosition="right">
                    <i class="fa fa-hand-o-right" aria-hidden="true"></i>
                    <label class="mb-0">
                        <span *ngIf="referralBadgeCount!==0"
                            class="badge badge-danger badge-throb mx-1 my-0">{{referralBadgeCount}}</span>
                    </label>
                </a>
                <a *ngIf="CanAccessPractices && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/referrals/practices" matTooltip="Practices" matTooltipPosition="right">
                    <i class="fa fa-hand-o-right" aria-hidden="true"></i>
                </a>
                <a *ngIf="canViewPatientImportFileList && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/configurations/imported-patient-files-list" matTooltip="Imported Files List"
                    matTooltipPosition="right">
                    <i class="fa fa-files-o"></i>
                </a>
                <a *ngIf="canAccessPatientFileConfiguration && !showFullMenu" mat-list-item
                    routerLinkActive="link-active" routerLink="/configurations/patient-file-configuration"
                    matTooltip="Patient File Configuration" matTooltipPosition="right">
                    <i class="fa fa-cogs"></i>
                </a>
                <a *ngIf="CanAccessCQCTemplates && !showFullMenu" class="px-2" mat-list-item
                    routerLinkActive="link-active" routerLink="/configurations/practice-templates"
                    matTooltip="CQC Templates" matTooltipPosition="right">
                    <i class="fa fa-book" aria-hidden="true"></i>
                </a>
                <a *ngIf="canAccessPermissions && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/configurations/permissions" matTooltip="Permissions" matTooltipPosition="right">
                    <i class="fa fa-handshake-o"></i>
                </a>
                
                <a *ngIf="canAccessRoles && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="/configurations/staff-roles" matTooltip="Staff Roles" matTooltipPosition="right">
                    <i class="fa fa-address-book"></i>
                </a>
                <a *ngIf="CanAccessPracticeConfiguration && !showFullMenu" mat-list-item routerLinkActive="link-active"
                    routerLink="configurations/view-rooms-config" matTooltip="Practice Configuration"
                    matTooltipPosition="right">
                    <i class="fa fa-cogs"></i>
                </a>
                <a *ngIf="CanAccessServerSettings && !showFullMenu" class="px-2" mat-list-item
                    routerLinkActive="link-active" routerLink="/configurations/servers-config"
                    matTooltip="Servers Configuration" matTooltipPosition="right">
                    <i class="fa fa-cogs" aria-hidden="true"></i>
                </a>
                <a *ngIf="CanAccessEmailSettings && !showFullMenu" class="px-2" mat-list-item
                    routerLinkActive="link-active" routerLink="/configurations/emails-config"
                    matTooltip="Emails Configuration" matTooltipPosition="right">
                    <i class="fa fa-cogs" aria-hidden="true"></i>
                </a>
                <mat-accordion *ngIf="canAccessConfiguration && showFullMenu">
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="fa fa-cog"></i>
                                <span *ngIf="showFullMenu">Configuration</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <a *ngIf="canViewPatientImportFileList" class="px-2" mat-list-item
                            routerLinkActive="link-active" routerLink="/configurations/imported-patient-files-list">
                            <i class="fa fa-files-o"></i>
                            <span>Patient Import Files</span>
                        </a>
                        <a *ngIf="canAccessPatientFileConfiguration" class="px-2" mat-list-item
                            routerLinkActive="link-active" routerLink="/configurations/patient-file-configuration">
                            <i class="fa fa-cogs"></i>
                            <span>Patient File Configuration</span>
                        </a>
                        <a *ngIf="CanAccessCQCTemplates" class="px-2" mat-list-item routerLinkActive="link-active"
                            routerLink="/configurations/practice-templates">
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <span>CQC Templates</span>
                        </a>                      
                        <mat-accordion *ngIf="showFullMenu">
                            <mat-expansion-panel *ngIf="canAccessPermissions">
                                    <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <i class="fa fa-handshake-o"></i>
                                                <span *ngIf="showFullMenu">Permissions</span>
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>
                            <a  class="px-2" mat-list-item routerLinkActive="link-active"
                                routerLink="/configurations/permissions">
                                <i class="fa fa-handshake-o" style="margin-right: 15px;"></i>
                                <span>Role Permissions</span>
                            </a>
                            <a class="px-2" mat-list-item routerLinkActive="link-active"
                                routerLink="/configurations/rotapermissions">
                                <i class="fa fa-handshake-o" style="margin-right: 15px;"></i>
                                <span>Rota Permissions</span>
                            </a>
                            </mat-expansion-panel>
                        </mat-accordion>
                        <a *ngIf="canAccessRoles" class="px-2" mat-list-item routerLinkActive="link-active"
                            routerLink="/configurations/staff-roles">
                            <i class="fa fa-address-book"></i>
                            <span>Roles</span>
                        </a>
                        <a *ngIf="CanAccessPracticeConfiguration" class="px-2" mat-list-item
                            routerLinkActive="link-active" routerLink="/configurations/view-rooms-config">
                            <i class="fa fa-book" aria-hidden="true"></i>
                            <span>Practice Configuration</span>
                        </a>
                        <a class="px-2" *ngIf="CanAccessEmailSettings" mat-list-item routerLinkActive="link-active"
                            routerLink="/configurations/servers-config">
                            <i class="fa fa-files-o"></i>
                            <span>IMAP Server Configuration</span>
                        </a>
                        <a class="px-2" *ngIf="CanAccessServerSettings" mat-list-item routerLinkActive="link-active"
                            routerLink="/configurations/emails-config">
                            <i class="fa fa-files-o"></i>
                            <span>Emails Configuration</span>
                        </a>
                    </mat-expansion-panel>
                </mat-accordion>
                <div class="version" *ngIf="showFullMenu">
                    Version {{version}}
                </div>
            </mat-nav-list>
        </mat-sidenav>

        <mat-sidenav-content>
            <mat-toolbar>
                <div mat-icon-button matTooltip="Menu" matTooltipPosition="below" (click)="toggle()"
                    class="position-fixed cursor" style="z-index: 99;">
                    <mat-icon>menu</mat-icon>
                </div>
                <!-- <marquee style="background-color: red;">This is test site</marquee> -->
                <div class="spacer"></div>
                <div class="position-fixed d-flex" style="right: 0;z-index: 99;">
                    <div mat-icon-button matTooltip="Reset Password" matTooltipPosition="below"
                        *ngIf="auth.isLoggedIn() && !IsMemberPrivilagePlan" routerLink="/hr-management/forgot-password"
                        class="cursor ml-3">
                        <mat-icon>lock</mat-icon>
                    </div>
                    <div *ngIf="auth.isLoggedIn() && !IsMemberPrivilagePlan" matTooltip="Log Out"
                        matTooltipPosition="below" class="cursor ml-3 mr-3" (click)="logout()" mat-icon-button>
                        <mat-icon>power_settings_new</mat-icon>
                    </div>
                </div>
            </mat-toolbar>
            <div style="padding: 20px; margin-top: 50px;padding-right: 60px;">
                <ng-content></ng-content>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>